import styled from "styled-components";

export const Icon = styled.i`
    color: ${props => props.color};
    font-size: ${props => props.size};
    cursor: ${props => (props.onClick ? "pointer" : undefined)};
`;
